<template>
  <header :class="[headerPadding, 'bg-slate-50 lg:pt-20']">
    <div
      class="fixed left-0 top-0 z-[999] flex w-screen min-w-[360px] flex-col bg-white text-lg drop-shadow lg:h-20 lg:flex-row lg:items-center"
    >
      <nav id="logo" class="flex w-full items-center justify-between lg:p-0">
        <NuxtLinkLocale to="/" class="inline-block px-5 py-[19px] lg:w-48 lg:px-[30px] lg:py-7">
          <img class="w-[96px] lg:w-36" src="assets/svg/logo.svg" :alt="$t('header.logo')" />
        </NuxtLinkLocale>

        <ul class="inline-flex items-center justify-end">
          <li v-for="item in menu" :key="item.key" class="hidden max-w-max text-center lg:block lg:px-[35px]">
            <NuxtLinkLocale
              :class="['text-lg font-bold ', $route.path.includes(item.path) ? 'text-blue-600' : 'text-slate-700']"
              :to="item.path"
              :target="item.target"
              :rel="item.rel"
            >
              {{ $t(item.key) }}
            </NuxtLinkLocale>
          </li>

          <div v-if="authStore.isLogin" class="inline-flex flex-row gap-1 lg:px-2.5">
            <RoundButton @click="logout()">{{ $t('header.logout') }}</RoundButton>
            <NuxtLinkLocale v-slot="{navigate}" custom to="/auth/my">
              <RoundButton @click="navigate">{{ $t('header.my') }}</RoundButton>
            </NuxtLinkLocale>
          </div>

          <div v-else class="lg:px-2.5">
            <NuxtLinkLocale v-slot="{navigate}" custom to="/auth/login">
              <RoundButton @click="navigate">{{ $t('header.login') }}</RoundButton>
            </NuxtLinkLocale>
          </div>

          <div class="h-14 lg:mr-0">
            <LanguageVue />
          </div>
        </ul>
      </nav>

      <nav class="inline-flex min-h-14 justify-between overflow-hidden px-2.5 lg:hidden">
        <ul class="grid w-full grid-cols-4 items-center text-sm">
          <li
            v-for="item in menu"
            :key="item.key"
            class="py-3 text-center text-center text-[13px] font-bold text-slate-700"
          >
            <NuxtLinkLocale
              :class="{['text-blue-600']: $route.path.includes(item.key)}"
              :to="item.path"
              :target="item.target"
              :rel="item.rel"
            >
              {{ $t(item.key) }}
            </NuxtLinkLocale>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script setup>
import RoundButton from '~/components/header/RoundButton.vue'
import LanguageVue from '~/components/header/Language.vue'

const authStore = useAuthStore()
const perqStore = usePerqStore()
const {locale} = useI18n()
const headerPadding = computed(() => {
  return locale.value === 'ko' ? 'pt-[100px]' : 'pt-[115px]'
})

const localeRoute = useLocaleRoute()
const logout = () => {
  authApi.logout().then(() => {
    authStore.resetVariables()
    perqStore.clearResponse()
    navigateTo(localeRoute('/'), {replace: true})
  })
}

const menu = [
  {key: 'header.intro', name: '소개', path: '/introduction/guardiann'},
  {key: 'header.dr-rodin', name: 'Dr.로딘 상담', path: '/dr-rodin'},
  {key: 'header.pqtest', name: '테스트', path: '/pqtest'},
  {
    key: 'header.inquire',
    name: '문의하기',
    path: 'https://forms.office.com/pages/responsepage.aspx?id=mARMW1KbfUCIpfbj_K4-sEZDh60GOGNItcuNplAYRGZUNDZLNENCRkdOQTJZUERDMEpNUVk5M0lZSS4u',
    target: '_blank',
    rel: 'noopener noreferrer'
  }
]
</script>

<style lang="scss" scoped></style>
